import { util, EventBus } from 'pevueglobal'
import { questiontypes } from '../../pages/public/evaluaties/evalquestiontypes'

const state = () => ({
  questions: [],
  questionanswers: [],
  questiontrigger: [],
  evalformdata: [],
  chapters: [],
  questionchoice: [],
  currentchapter: 0,
  evaldone: false,
  validationtriggered: false,
  type: null,
  guid: null,
})

// getters
const getters = {
  questionchoice: (state) => state.questionchoice,
  chapters: (state) => state.chapters,
  evalformdata: (state) => state.evalformdata[0],
  questions: (state) => state.questions,
  questionanswers: (state) => state.questionanswers,
  currentchapter: (state) => state.currentchapter,
  evaldone: (state) => state.evaldone,
  validationtriggered: (state) => state.validationtriggered,
  type: (state) => state.type,
  istriggerquestion: (state) => (questionID, chapterid) => {
    let datafilt = state.questiontrigger[chapterid].filter((o) => {
      return o.tblQuestionChapterAnswerTriggerQuestionID === questionID
    })
    return datafilt.length !== 0
  },
}

function getstatequestiontriggered(vraagid, chapterid, questiontrigger, questions, vraagvalue = null) {
  // toon of verberg de vraag na trigger

  // check of er een trigger vraag moet worden geopend
  let istriggeredquestion = questiontrigger[chapterid].filter((o) => {
    return o.tblQuestionChapterAnswerTriggerQuestionID === vraagid
  })

  if (istriggeredquestion.length !== 0) {
    let triggerquestion = questions[chapterid].filter((question) => {
      return question.tblQuestionID === istriggeredquestion[0].tblQuestionID
    })[0]

    vraagvalue = vraagvalue === null ? triggerquestion.qvalue : vraagvalue

    // Check of dat dit een checkboxlist is

    let istriggeranswer

    if (questiontypes[triggerquestion.tblquestiontypecode].type === 'XVcheckboxlist') {
      istriggeranswer = questiontrigger[chapterid].filter((o) => {
        return (
          o.tblQuestionChapterAnswerTriggerQuestionID === vraagid &&
          vraagvalue !== undefined &&
          vraagvalue.indexOf(o.tblDefaultAnswersID) !== -1
        )
      })
    } else {
      istriggeranswer = questiontrigger[chapterid].filter((o) => {
        // console.log('vraagid', vraagid)
        // console.log('TblDefaultAnswersID', o.tblDefaultAnswersID)
        // console.log('TblQuestionChapterAnswerTriggerQuestionID', o.tblQuestionChapterAnswerTriggerQuestionID)

        return o.tblQuestionChapterAnswerTriggerQuestionID === vraagid && o.tblDefaultAnswersID === Number(vraagvalue)
      })
      // console.log('istriggeranswer', istriggeranswer)
    }

    return istriggeranswer.length !== 0
  } else {
    return false
  }
}

// actions
const actions = {
  getTexten: async ({ dispatch }) => {
    let textIDs = [
      17, 29, 758, 2030, 3599, 4848, 4849, 14268, 14322, 14323, 14324, 14320, 14321, 14326, 14327, 14345, 14457, 14491,
      16580, 16581, 16582,
    ]
    dispatch('gettranslations', textIDs, { root: true })
  },
  getevaldata: async ({ commit, state, dispatch }, evalinputpars) => {
    // haal chapter data op, evalinputpars zijn { myguid: myguid, type:type }
    state.type = evalinputpars.type
    state.guid = evalinputpars.myguid
    let data = await util.getDataApi('public/PEapi_sp_evaluation', evalinputpars)
    if (data.status === '200') {
      commit('setevaldata', data.ds)

      // haal chapter data op
      let personevalid = state.evalformdata[0].personevalid !== null ? state.evalformdata[0].personevalid : 0
      let courseID = state.evalformdata[0].courseID !== null ? state.evalformdata[0].courseID : 0
      let formid = state.evalformdata[0].tblEvaluationFormID
      if (state.evalformdata[0].datefilled !== null) {
        state.evalformdata[0].datefilledMSF = new Date(state.evalformdata[0].datefilled)
      } else {
        state.evalformdata[0].datefilledMSF = new Date()
      }
      if (evalinputpars.readonly === true) {
        state.evalformdata[0].datefilled = new Date()
      }

      let dataquestions = await util.getDataApi('public/PEapi_sp_evaluation_retrieve_questions', {
        formid: formid,
        personevalid: personevalid,
        type: state.type,
        courseid: courseID,
      })
      if (dataquestions.status === '200') {
        commit('setchapterdata', { data: dataquestions.ds })
      }
    }
    commit('stopLoading', null, { root: true })
  },
  saveformvalue: async ({ commit, state }, input) => {
    let vraagid = input.id
    let personevalid = state.evalformdata[0].personevalid !== null ? state.evalformdata[0].personevalid : 0 // personevalid leeg = preview mode
    let answer = null
    if (typeof input.newvalue === 'string') {
      if (input.newvalue.trim() !== '') {
        // input lege string dan null opslaan bij tijdelijk opslaan anders gaat de server validatie niet af, we kunnen niet naspelen hoe mensen de client validatie kunnen skippen, maar blijkbaar zijn er gevallen waar dit gebeurd issueNR 12561
        answer = input.newvalue
      }
    } else if (input.type === 'XVdate') {
      answer = util.jsDateToStringDate(input.newvalue)
    } else {
      if (input.type === 'XVcheckboxlist') {
        answer = input.newvalue.join(',')
      } else {
        answer = input.newvalue
      }
    }

    if (personevalid !== 0) {
      commit('startLoading', { showmessage: true, disablepage: false }, { root: true })
      let answerdata
      if (input.answerTextID === null) {
        answerdata = {
          personevalid: personevalid,
          type: state.type,
          answer: answer,
          questionID: vraagid,
          answerTextID: answer,
          tblDefaultAnswersScore: 0,
        } // openvraag, veld met answertextid word nu gevuld met antwoord
      } else {
        answerdata = {
          personevalid: personevalid,
          type: state.type,
          answer: answer,
          questionID: vraagid,
          answerTextID: input.answerTextID,
          tblDefaultAnswersScore: input.defaultAnswersScore,
        }
      }

      await util.getDataApi('public/PEapi_sp_evaluation_save_answer', answerdata)
      // if (data.status === '200') {
      //   commit('saveformvalue', input)
      commit('stopLoading', null, { root: true }) // werkt nog niet moet eerst een event voor laden chapter komen
      // }
    }
  },
  nvtchanged: async ({ commit, state }, input) => {
    let personevalid = state.evalformdata[0].personevalid !== null ? state.evalformdata[0].personevalid : 0 // personevalid leeg = preview mode
    let intnvt = input.nvtvalue === true ? 1 : 0

    if (personevalid !== 0) {
      commit('startLoading', { showmessage: true, disablepage: false }, { root: true })
      let answerdata = {
        personevalid: personevalid,
        type: state.type,
        answer: input.questionValue,
        questionID: input.questionID,
        na: intnvt,
      }
      let data = await util.getDataApi('public/PEapi_sp_evaluation_save_answer_NA', answerdata)
      if (data.status === '200') {
        commit('stopLoading', null, { root: true })
        commit('nvtchanged', input)
        // EventBus.$emit('updateloading', 1)      werkt nog niet moet eerst een event voor laden chapter komen
      }
    }
  },
  nextchapter: async ({ commit, state, getters }, finish) => {
    commit('startLoading', { showmessage: false, disablepage: false }, { root: true })
    // als hoofdstuk klaar is volgende hoofdstuk laden
    if (finish === false) {
      commit('nextchapter', false)
    } else {
      // evaluatie klaar!!! set evaluatie datum
      let personevalid = state.evalformdata[0].personevalid !== null ? state.evalformdata[0].personevalid : 0 // personevalid leeg = preview mode

      if (personevalid !== 0) {
        // check alle vragen van alle hoofdstukken
        let verplichtNietIngevuld = state.questionchoice.filter((val, index) => {
          let istriggerquestion = getters.istriggerquestion(val.questionID, val.chapterindex)
          let nietingevuld // test of vraag is ingevuld
          if (istriggerquestion) {
            nietingevuld =
              val.nvt === false &&
              val.value === undefined &&
              val.questiontriggered &&
              val.tblQuestionchapterObligatory === 1
            // nvt is niet ingevuld, vraag heeft een lege value, vraag is getriggered en de vraag is verplicht
          } else {
            nietingevuld =
              val.nvt === false &&
              (val.value === undefined || val.value === []) &&
              val.tblQuestionchapterObligatory === 1
            // nvt is niet ingevuld, vraag heeft een lege value en de vraag is verplicht
          }

          return nietingevuld // niet ingevuld dus doorlaten
        })

        if (verplichtNietIngevuld.length === 0) {
          let values = state.questionchoice.map((q) => {
            let Questionanswer = state.questionanswers[q.chapterindex].filter(
              // PE-13853 TblDefaultAnswersScore score in person evaluaties waren altijd 1
              // extra afvraging erbij gezet, niet het goede score erbij gehaald
              (qa) => qa.tblQuestionID === q.questionID && qa.tblDefaultAnswersID === parseInt(q.value)
            )[0] // zoek meer keuze antwoord op, als deze leeg is , dan is het een open vraag

            let qvalue = ''
            // PE-14683    Verzenden Datum formaat MSF moet naar NL formaat
            if (questiontypes[q.type].type === 'XVdate') {
              if (q.value !== null) {
                qvalue = util.jsDateToStringDate(q.value)
              } else {
                qvalue = q.value
              }
            } else if (questiontypes[q.type].type === 'XVcheckboxlist') {
              qvalue = q.value.join(',')
            } else {
              qvalue = q.value
            }
            if (Questionanswer) {
              // checkboxlist moet comma gescheiden

              return {
                questionID: q.questionID,
                answerTextID: qvalue,
                answer: qvalue,
                tblDefaultAnswersScore: Questionanswer.tblDefaultAnswersScore,
                nvt: q.nvt ? 1 : 0,
              }
            } else {
              return {
                questionID: q.questionID,
                answerTextID: qvalue,
                answer: qvalue,
                tblDefaultAnswersScore: 0, // score 0 bij open vraag
                nvt: q.nvt ? 1 : 0,
              }
            }
          })

          let finishdata = { personevalid: personevalid, type: state.type, values: values }

          let data = await util.getDataApi('public/PEapi_sp_evaluation_finish', finishdata)
          if (data.status === '200') {
            if (data.ds.data0[0].error === 1) {
              util.throwException(
                'Verplichte velden niet gevuld volgens finisheval',
                { verplichtNietIngevuld: verplichtNietIngevuld, Allevragen: state.questionchoice },
                14592
              )
            } else {
              // set eval session, zodat men pe weer in kan (zie peapp/default.aspx)
              await util.getData('/peapp/eval/finisheval')
              commit('nextchapter', true)
            }
          }
        } else {
          util.throwException(
            'Verplichte velden niet gevuld',
            { verplichtNietIngevuld: verplichtNietIngevuld, Allevragen: state.questionchoice },
            14592
          )
        }
      } else {
        commit('nextchapter', true)
      }
    }
    commit('stopLoading', null, { root: true })
  },
}

// mutations
const mutations = {
  triggervalidation(state, inputpars) {
    EventBus.$emit('validatechapters', 0, false)
  },
  RESET(s) {
    // reset state to initial state
    const initial = state()
    Object.keys(initial).forEach((key) => {
      s[key] = initial[key]
    })
  },
  nextchapter(state, evaldone) {
    if (evaldone === true) {
      state.evaldone = true
    } else {
      state.currentchapter++ // in evalchapter staat een watch, deze kijkt of het hoofdstuk id veranderd, en haalt dat nieuwe data op via een mutatie
    }
  },
  nvtchanged(state, input) {
    // reset choice, nvt so value must be empty
    state.questionchoice[input.index].value = null
  },
  setchapterdata(state, inputpars) {
    var questionindex = 0
    state.chapters.forEach((c, chapterindex) => {
      c.chapterindex = chapterindex

      state.questions.push(inputpars.data['data' + 3 * chapterindex])
      state.questionanswers.push(inputpars.data['data' + (1 + 3 * chapterindex)])
      state.questiontrigger.push(inputpars.data['data' + (2 + 3 * chapterindex)])

      // vul choices array, array waar alle antwoorden zijn opgeslagen

      state.questions[chapterindex].forEach((qc, index) => {
        qc.questionindex = questionindex
        // als er nog niets is ingevuld de defaultvalue vullen
        if (qc.qvalue === '' && qc.tblQuestionDefaultValue !== null) {
          qc.qvalue = qc.tblQuestionDefaultValue
        }

        // voor de checkboxlit de komma gescheiden waarde naar array omzetten

        if (questiontypes[qc.tblquestiontypecode].type === 'XVcheckboxlist') {
          if (qc.qvalue !== undefined) {
            let splitstring = qc.qvalue.split(',')
            let intar = []
            splitstring.forEach((v) => {
              intar.push(Number(v))
            })
            qc.qvalue = intar
          } else {
            qc.qvalue = []
          }
        }
        if (questiontypes[qc.tblquestiontypecode].type === 'XVdate') {
          qc.qvalue = util.parseDate(qc.qvalue)
          // PE-14683    Verzenden Datum formaat MSF moet naar NL formaat
        }

        let isQuestiontriggered = getstatequestiontriggered(
          qc.tblQuestionID,
          chapterindex,
          state.questiontrigger,
          state.questions
        )

        state.questionchoice.push({
          id: 'vraag' + qc.tblQuestionID, // zelfde id als in evaluaties.vue op het component  <component :id="'vraag'+item.tblQuestionID" >
          questionID: qc.tblQuestionID,
          value: qc.qvalue,
          type: qc.tblquestiontypecode,
          nvt: qc.na === 1, // als NA 1 is dan is nvt true
          questiontriggered: isQuestiontriggered,
          chapterindex: chapterindex,
          tblQuestionValidateFunction: qc.tblQuestionValidateFunction,
          tblQuestionchapterObligatory: qc.tblQuestionchapterObligatory,
        })
        questionindex++
      })
    })

    EventBus.$emit('chapterdataloaded', 1)
  },
  setevaldata(state, data) {
    state.evalformdata = data.data0
    state.chapters = data.data1
    // state.evalformdata[0].chaptersOnOnePage = 1
    EventBus.$emit('chapterdataloaded', 0)
  },
  prevchapter(state) {
    $(window).scrollTop(0)
    state.currentchapter-- // ga een hoofdstuk terug
  },
  setvalidationtriggered(state, v) {
    state.validationtriggered = v
  },
  questiontriggered(state, data) {},
  setstatetriggerquestion: function (state, data) {
    // check of er een trigger vraag moet worden geopend
    let istrigger = state.questiontrigger[data.chapterid].filter((o) => {
      return o.tblQuestionID === data.vraagid && data.vraagvalue === o.tblDefaultAnswersID
    })[0]
    let isnottrigger = state.questiontrigger[data.chapterid].filter((o) => {
      return o.tblQuestionID === data.vraagid && data.vraagvalue !== o.tblDefaultAnswersID
    })

    if (istrigger) {
      let isQuestiontriggered = getstatequestiontriggered(
        istrigger.tblQuestionChapterAnswerTriggerQuestionID,
        data.chapterid,
        state.questiontrigger,
        state.questions,
        data.vraagvalue
      )
      state.questionchoice.forEach((o) => {
        // lijst met niet getriggerde antwoorden
        isnottrigger.forEach((nottq) => {
          // zoek de trigger vraag op die niet getoond moet worden en set op false
          if (o.questionID === nottq.tblQuestionChapterAnswerTriggerQuestionID) {
            o.questiontriggered = false
            o.value = '' // set de trigger question value op leeg, i.v.m. n.v.t.
          }
        })

        // zoek de vraag die wel getoond moet worden en zet op true
        if (o.questionID === istrigger.tblQuestionChapterAnswerTriggerQuestionID) {
          if (isQuestiontriggered) {
            o.questiontriggered = true
          } else {
            o.questiontriggered = false
            o.value = '' // set de trigger question value op leeg, i.v.m. n.v.t.
          }
        }
      })
    }
  },
}

export default {
  namespaced: true,
  state: state(),
  getters,
  actions,
  mutations,
}
